/**
 * admin.js
 * Path: frontend/src/api/admin.js
 * Description: Wywołania API administracji użytkownikami.
 * Related: pages/AdminUsersPage.jsx
 */

import { api, authHeaders } from "./apiBase";

function normalizeUser(item = {}) {
  return {
    id: item.id,
    email: item.email || "",
    name: item.name || "",
    role: item.role || "worker",
    active: item.active !== false,
    needsPasswordSet: item.needs_password_set === true || item.needsPasswordSet === true,
    createdAt: item.created_at || item.createdAt || null,
  };
}

export async function listAdminUsers(token) {
  const response = await api.get("/admin/users", { headers: authHeaders(token) });
  return Array.isArray(response.data) ? response.data.map(normalizeUser) : [];
}

export async function createAdminUser(token, payload) {
  const response = await api.post("/admin/users", payload, { headers: authHeaders(token) });
  return normalizeUser(response.data);
}

export async function updateAdminUser(token, id, payload) {
  const response = await api.patch(`/admin/users/${id}`, payload, { headers: authHeaders(token) });
  return normalizeUser(response.data);
}

export async function resetAdminUserPassword(token, id) {
  const response = await api.post(
    `/admin/users/${id}/reset-password`,
    {},
    { headers: authHeaders(token) }
  );
  return {
    user: normalizeUser(response.data),
    temporaryPassword: String(response.data?.temporaryPassword || ""),
    temporaryPasswordExpiresAt: String(response.data?.temporaryPasswordExpiresAt || ""),
  };
}
